const ONLINE_THRESHOLD_MS = 5 * 60 * 1000 // 5 minutes

function isOnline(lastActivity: string): boolean {
  return Date.now() - new Date(lastActivity).getTime() < ONLINE_THRESHOLD_MS
}

function formatDateTime(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export function OnlineIndicator({ lastActivity }: { lastActivity: string | null }) {
  if (!lastActivity) {
    return <span className="text-muted-foreground text-[10px]">-</span>
  }

  if (isOnline(lastActivity)) {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] text-green-600">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-green-500" />
        Online
      </span>
    )
  }

  return <span className="text-muted-foreground text-[10px]">{formatDateTime(lastActivity)}</span>
}
